// Shared top chrome for every public + authed page (Landing, Projects,
// Pricing, Account, Admin, DslDocs, Terms, Privacy). Owns the brand,
// optional middle nav links, and the right-side action area.
//
// LangToggle is built in — every page that uses TopBar gets the language
// switch automatically; no per-page wiring.
//
// Studio doesn't use this (its header packs UsageChip + Save / Compile /
// Final — denser layout). Studio mounts its own <LangToggle /> inline.
//
// Slots:
//   links  — center column. e.g. <a>Features</a><Link>Pricing</Link>
//   right  — far-right column. e.g. <UserMenu /> or sign-in CTAs.
//
// Brand always links to `/` and reads as the autolecture chick + wordmark
// via the shared <Brand /> component.

import type { ReactNode } from 'react';
import { Brand } from './Brand';
import { LangToggle } from './LangToggle';
import './TopBar.css';

export interface TopBarProps {
  links?: ReactNode;
  right?: ReactNode;
}

export function TopBar({ links, right }: TopBarProps) {
  return (
    <header className="topbar">
      <Brand size={26} />
      {links && <nav className="topbar-links">{links}</nav>}
      <div className="topbar-right">
        <LangToggle />
        {right}
      </div>
    </header>
  );
}
